<template>
  <div class="page_wrapper">
    <div class="heading">
      <h1>
        Max and Christina's Wedding Website
      </h1>
    </div>
    <button v-if="$router.currentRoute.path !== '/'" class="goback" @click="$router.push('/')">
      <i class="fas fa-long-arrow-alt-left"></i> Menu
    </button>
    <slot/>
  </div>
</template>

<script>
export default {
name: "Main"
}
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css?family=Bungee+Shade");
.logo {
  margin: 1% 0 0 0;
  height: 10vh;
  padding: 5px;
  background: white;
  border-radius: 5px;
  box-shadow: 2px 2px 10px black;
}
a {
  text-decoration: none;
}

h1 {
  margin: 0 0 0 0;
  color: rgb(34, 34, 32);
  font-weight: 400;
  font-family: "Bungee Shade", cursive;
  font-size: 3vw;
  text-shadow: 3px 2px 4px rgba(0, 0, 0, 0.548);
}
.page_wrapper {
  text-align: center;
  background-image: url('../assets/images/background.png');
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
  overflow: hidden;
}
.menu_wrapper {
  /* margin: 0; */
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.box2 {
  grid-column-start: 1;
  grid-column-end: 5;
  grid-row-start: 1;
  grid-row-end: 1;
  display: grid;
  grid-template-columns: repeat(5, minmax(0,1fr));
}
img {
  max-width: 100%;
  max-height: 250px;
}
.nested_pic{
  grid-column: span 1;
}
.nested_txt{
  grid-column: span 4;
  justify-content: center;
}
table { margin: auto; }
.option img {
  transition: all 0.3s;
  margin: 5% 5% -2% 5%;
  width: 19vw;
  padding: 5%;
  border: 2px solid lightblue;
  border-radius: 10px;
  height: 12vw;
}
.option p {
  color: lightsalmon;
  text-align: center;
  font: 3vw Georgia, Times New Roman, serif;
}

.option {
  position: relative;
  top: 10vh;
  background: rgb(34, 34, 32);
  border-radius: 10px;
  width: 25vw;
  height: 25vw;
  -webkit-box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.3);
  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.3);
  padding: 4%;
}
.box {
  margin: 0 auto;
  background: rgb(200, 200, 200);
  border-radius: 10px;
  width: 75%;
  max-height: 85%;
  -webkit-box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.3);
  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.3);
  text-align: center;
  padding: 1% 2% 4%;
  opacity: 0.75;
  overflow-y:auto;
}
.larger {
  transform: scale(1.1, 1.1);
}

.option:hover {
  transition: all 0.3s;
  transform: scale(1.2, 1.2);
  border: 3px solid firebrick;
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.8);
}
.option:hover p {
  color: red;
}

.option:hover img {
  padding: 2%;
  border: 5px solid lightblue;
  border-radius: 10px;
}

@media screen and (max-width: 400px) {
  h1 {
    font-size: 20px;
  }
  .option img {
    height: 7vh;
  }
  .option {
    background: rgb(34, 34, 32);
    padding: 4%;
    height: 15vh;
    position: relative;
    top: 10vh;
    text-align: center;
  }
  .option p {
    margin: none;
    font-size: 10px;
    color: red;
  }
}
</style>

